import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { Constants } from 'utilities/constants';
import { parseISO, isBefore, startOfToday } from 'date-fns';

// const statuses = {
//   [Constants.MasterStatus.IMPORTED]: {
//     color: '#6e86ab', // Blue gray
//     text: 'Imported'
//   },
//   [Constants.MasterStatus.AVAILABLE]: {
//     color: '#58b2ff', // Bright blue
//     text: 'Available'
//   },
//   [Constants.MasterStatus.ASSIGNED]: {
//     color: '#e0cf00', // Gold
//     text: 'Assigned'
//   },
//   [Constants.MasterStatus.UNDERWRITEDONE]: {
//     color: '#67c12e', // Bright green
//     text: 'UW Done'
//   },
//   [Constants.MasterStatus.NOBID]: {
//     color: '#dc5151', // Red
//     text: 'No Bid'
//   },
//   [Constants.MasterStatus.SUBMITTED]: {
//     color: '#faa307', // Orange
//     text: 'Submitted'
//   },
//   [Constants.MasterStatus.COMPLETED]: {
//     color: '#a7a7a7', // Grey
//     text: 'Completed'
//   },
//   [Constants.MasterStatus.EXPIRED]: {
//     color: '#676767', // Dark Gray
//     text: 'Expired'
//   },
//   [Constants.MasterStatus.TERMINATED]: {
//     color: '#565656', // Black
//     text: 'Terminated'
//   }
// };

const opportunityStatuses = {
  [Constants.OpportunityStatus.IMPORTED]: {
    text: 'Imported',
    // color: '#231F20', // Black
    // color: '#6e86ab', // Blue gray
    color: '#565656', // Black
  },
  [Constants.OpportunityStatus.PRESCREEN]: {
    text: 'Pre-Screen',
    // color: '#5179BC', // Blue
    color: '#58b2ff', // Bright blue
    colorWaterfall: true
  },
  [Constants.OpportunityStatus.INITIAL]: {
    text: 'Initial',
    color: '#58b2ff', // Bright blue
    colorWaterfall: true
  },
  [Constants.OpportunityStatus.COUNTER]: {
    text: 'Counter',
    color: '#58b2ff', // Bright blue
    colorWaterfall: true
  },
  [Constants.OpportunityStatus.DUEDILIGENCE]: {
    text: 'Due Diligence',
    color: '#58b2ff', // Bright blue
    colorWaterfall: true
  },
  [Constants.OpportunityStatus.TERMINATED]: {
    text: 'Terminated',
    // color: '#848585', // Grey
    // color: '#565656', // Black
    color: '#a7a7a7', // Grey
  },
  [Constants.OpportunityStatus.COMPLETED]: {
    text: 'Completed',
    // color: '#848585', // Grey
    color: '#a7a7a7', // Grey
  }
};

export const getChipStatus = (txnOpp, expired) => {
  const { opportunityStatus } = txnOpp;
  const foundStatus = opportunityStatuses[opportunityStatus];
  if (!foundStatus) {
    console.log(`OpportunityStatusChip.js - opportunityStatus of ${opportunityStatus} not recognized`);
    return null;
  }
  let chipColor = foundStatus.color;
  if (foundStatus.colorWaterfall) { // Waterfall the chip color based on uw status
    if (txnOpp.underwriteStatus === Constants.UnderwriteStatus.SUBMITTEDPRICING) {
      chipColor = '#67c12e'; // Bright green
    } else if(txnOpp.underwriteStatus === Constants.UnderwriteStatus.SUBMITTEDNOBID) {
      chipColor = '#dc5151'; // Red
    } else if(txnOpp.underwriteStatus === Constants.UnderwriteStatus.SUBMISSIONPENDING) {
      chipColor = '#3AC78A'; // Light(ish) green
    } else if(txnOpp.underwriteStatus === Constants.UnderwriteStatus.SUBMISSIONFAILED) {
      chipColor = '#EA9696'; // Light(ish) red
    } else if(txnOpp.underwriteStatus === Constants.UnderwriteStatus.PENDING) {
      chipColor = '#E4C5AF'; // Dark yellow
    } else if (txnOpp.underwriteStatus === Constants.UnderwriteStatus.SAVEDNOBID || txnOpp.underwriteStatus === Constants.UnderwriteStatus.SAVEDPRICING || txnOpp.underwriteStatus === Constants.UnderwriteStatus.AUTOPRICED) {
      chipColor = '#faa307'; // Orange
    } else if (txnOpp.userId != null) { // has assigned user
      // chipColor = '#DCDD25'; // Yellow
      chipColor = '#e2c600'; // Gold #e0cf00
    } // else use opportunityStatus's default
  }

  const opacity = expired ? '8c' : ''; // 8c in hex equivalent to 0.55 opacity
  return {
    color: chipColor + opacity,
    text: foundStatus.text
  }
}

export const getTextForOpportunityStatusFields = (status) => {
  const foundStatus = opportunityStatuses[status];

  if (!foundStatus) {
    return null;
  }

  return {
    text: foundStatus.text
  }
}

const OpportunityStatusChip = ({ classes, style, txnOpp, noBackground, highlightStatus }) => {
  if (!txnOpp?.opportunityStatus) return null;
  const expired = txnOpp?.auctionDate ? isBefore(parseISO(txnOpp.auctionDate), startOfToday()) : false; // TODO: check if this is affected by timezone issue (ie auctionDate is in central time because of server location, but startOfToday will return UTC time with timezone based on user location)
  const myStatus = getChipStatus(txnOpp, expired);
  if (!myStatus) return null;
  return <Chip
    classes={{
      root: classes.compTypeChip,
      label: classes.label
    }}
    // style={{ backgroundColor: myStatus.color, width: 80, opacity: expired ? 0.55 : 1.0 }}
    style={{
      backgroundColor: noBackground ? 'transparent' : myStatus.color,
      color: noBackground ? 'rgba(0, 0, 0, 0.54)' : null,
      border: noBackground ? '1px solid rgba(0, 0, 0, 0.54)' : null,
      width: 90,
      ...style
    }}
    label={highlightStatus ? highlightStatus(myStatus.text) : myStatus.text}
  />
}

const styles = theme => ({
  compTypeChip: {
    height: 18,
    color: '#fff'
  },
  label: {
    overflow: 'initial'
  }
});

export default withStyles(styles)(OpportunityStatusChip);
